const mapLocale = {
    'GeolocateControl.FindMyLocation': 'Localiser',
    'GeolocateControl.LocationNotAvailable': 'Géolocalisation non disponible',
    'LogoControl.Title': 'Mapbox logo',
    'NavigationControl.ResetBearing': 'Réinitialiser le Nord',
    'NavigationControl.ZoomIn': 'Zoomer',
    'NavigationControl.ZoomOut': 'Dézoomer',
};

export default mapLocale;